export default function Reasons() {

  const items = [
    { title: '20x sales growth',
      description: "Our clients have achieved over 20x their online sales with our account management and advertising services."
    },
    { title: '100+ clients',
      description: "We have promoted over 100+ businesses worldwide, our experience sets us apart from the crowd."
    },
    { title: 'Experience over 7 years',
      description: "Our team has been selling on Amazon for over 7 years. We have hundreds of successful customer cases in various niches."
    },
    { title: 'We are active Amazon sellers too.',
      description: "Grow your business fast and successfully with the help of people who truly get what they want. We will help you solve most of the problems you are facing right now."
    },
    { title: 'We sell 20000 items every month',
      description: "Together with our customers, we sell more than 20,000 unique products. Diverse markets and niches, various products, and numerous customers. Rest assured - we know how to sell your product!"
    },
    { title: 'Individual approach',
      description: "Every business and every product has its characteristics. We study your goals, research your products and markets, and then design a customized development strategy that will help you to conquer Amazon and achieve what you want!"
    }
  ];

  return (
    <section id="reasons" className="block block-reasons">
      <div className="container">
        <h2 className="fw-bold text-center">And even more, reasons to choose us!</h2>
        <div className="row g-4">
          {items.map((item, index) => (
            <div className="col-12 col-sm-6 col-lg-4" key={index}>
              <div className="item p-4">
                  <h4 className="title fw-bold d-flex align-items-center">{item.title}</h4>
                  <div className="description text-start">
                    {item.description}
                  </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
